import { StateProxy } from "./StateProxy.js";
import { StateMachine } from "./StateMachine.js";
export function CreateState(data) {
    return StateProxy.createProxy(data);
}
export function CreateMachine(stateMachineData) {
    return new StateMachine(stateMachineData);
}
